export function formatEmiratesId(value?: string | null) {
  if (!value) return '';

  const digits = value.replace(/\D/g, '');

  return digits.replace(/^(\d{3})(\d{4})(\d{7})(\d)$/, '$1-$2-$3-$4');
}
